import { evolve } from 'ramda';
import { parseStringDate } from 'common/dateFnsUtils';

export interface BusinessPartnerDataDTO {
  name: string;
  uniqueNumber: string;
  description?: string;
}

export interface BusinessPartnerDTO {
  createDate: string;
  id: number;
  name: string;
  uniqueNumber: string;
  description?: string;
  numberOfDevices?: number;
  items?: object;
  parentPartnerId?: number;
  subaprtnerIds?: number[];
}

export interface BusinessPartner {
  active?: boolean;
  createDate: Date;
  id: number;
  name: string;
  uniqueNumber: string;
  description?: string;
  numberOfDevices?: number;
  parentPartnerId?: number;
  subaprtnerIds?: number[];
}

export const mapToBusinessPartner = (
  dto: BusinessPartnerDTO
): BusinessPartner =>
  evolve(
    {
      createDate: parseStringDate,
    },
    dto
  );

export type BusinessPartnerCtx = BusinessPartner;
